// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1YyDj","right":"Footer_right__2iG-A","buttons":"Footer_buttons__tkXHA"};